module.exports = "<h4 l10nTranslate class=\"title-client-detail\">TITLE_CLIENT_DETAIL</h4>\n<div class=\"client-detail\">\n  <div>\n      <p l10nTranslate class=\"label\">NAME_SURNAME</p>\n      <p> {{ data.FirstName }} {{data.LastName}}</p>\n      <p l10nTranslate class=\"label\">CF_FISCAL</p>\n      <p>{{ data.fiscalCode }}</p>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/alg-email-management/alg-email-management-customer-info/alg-email-management-customer-info.component.html
// module id = ./src/app/components/alg-email-management/alg-email-management-customer-info/alg-email-management-customer-info.component.html
// module chunks = main